import BaseCollection from "nexia_mobile/models/base_collection";
import UserCode from "nexia_mobile/models/user_code";
import UserCodeSchema from "nexia_mobile/models/user_code_schema";

export default class UserCodeCollection extends BaseCollection {
  model = UserCode;

  createNewCode() {
    let code = new UserCode({ href: this.url() }, { parse: true });
    this.add(code);
    return code;
  }

  getEditSchemaClass() {
    return UserCodeSchema;
  }

  parse(...args) {
    let codes = super.parse(...args);
    if (!_.isArray(codes)) {
      return [];
    }

    return codes.map((code) => {
      code.href = this.url().replace(/\/user_codes/, `/user_codes/${code.id}`);
      return code;
    });
  }

  async _parseModelsAsync(...args) {
    let codes = await super._parseModelsAsync(...args);
    if (!_.isArray(codes)) {
      return [];
    }

    // no further awaiting is needed; this is a fast operation
    return codes.map((code) => {
      code.href = this.url().replace(/\/user_codes/, `/user_codes/${code.id}`);
      return code;
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/user_code_collection.js